import {Button, Col, Modal, Row} from "react-bootstrap";
import {
  generateForm, generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../HoTroKyThuatChuyenMon";
import {Formik, Form} from "formik";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import LabelRequired from "../../../../component/LabelRequired";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import TableNhanLuc from "../../co-so-kb-cb/components/TableNhanLuc";
import {searchOptionNhanVien} from "../../co-so-kb-cb/services/services";
import {CODE, MAX_PAGE_SIZE} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import {saveDot} from "../services/services";

interface Props {
  show: boolean;
  onHide: () => void;
  getListDsDot?: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  type: TypeKeHoach;
}

// Định nghĩa các type cho nhân lực
const STAFF_TYPES = {
  RECIPIENT: 'recipientGroup',
  SUPPORT_STAFF: 'supportStaff'
};

const DialogBienBanHoTro = (props: Props) => {
  const {show, onHide, setInitialValues, initialValues, type, getListDsDot} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [thanhVien, setThanhVien] = useState<any>([]);
  const [editingIndexTren, setEditingIndexTren] = useState<number | null>(null);
  const [selectedTiepNhanHoTro, setSelectedTiepNhanHoTro] = useState<any>(null);
  const [selectedCanBoHoTro, setSelectedCanBoHoTro] = useState<any>(null);

  // Thay đổi cấu trúc dataNhanLuc - chỉ có batchStaffList
  const [dataNhanLuc, setDataNhanLuc] = useState<any>({
    batchStaffList: [],
  });

  const handleFormSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      const dataSubmit = {
        ...values[type?.formThongTinChung],
        staffList: [...dataNhanLuc?.batchStaffList],
      };
      const id = values[type?.formThongTinChung]?.id;
      const {data} = await saveDot(id, dataSubmit)
      console.log(data)
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        // setInitialValues && setInitialValues(data?.data);
        // setDetailPhieuKeHoach({
        //   ...data?.data,
        //   statusId: detailPhieuKeHoach?.statusId,
        // });
        toast.success("Thành công");
        onHide();
        getListDsDot && getListDsDot();
      } else {
        let errorMessage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMessage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getOptions = async () => {
    try {
      setIsLoading(true);
      const [nhanVien] = await Promise.all([
        searchOptionNhanVien({pageSize: MAX_PAGE_SIZE}),
      ]);

      setThanhVien(nhanVien?.data?.data?.content ?? []);
    } catch (e) {
      console.error("Lỗi khi tải danh sách:", e);
      toast.error("Không thể tải danh sách nhân viên và vai trò");
    } finally {
      setIsLoading(false);
    }
  };

  // Hàm thêm hoặc cập nhật - lưu vào batchStaffList với type
  const handleAddOrUpdate = (itemSelected: any, staffType: string) => {
    if (!itemSelected) {
      toast.warning('Vui lòng chọn nhân sự');
      return;
    }

    const newItem = {
      personnel: itemSelected?.code || "",
      personnelName: itemSelected?.name || "",
      position: itemSelected?.position || "",
      positionName: itemSelected?.chucVu || "",
      unit: itemSelected?.unitName || itemSelected?.department || "",
      unitName: itemSelected?.unitName || itemSelected?.department || "",
      degree: "",
      degreeName: "",
      experience: "",
      currentCapacity: "",
      currentCapacityName: "",
      item: itemSelected,
      levelType: staffType, // Thêm trường type để phân biệt
    };

    if (editingIndexTren !== null) {
      const updatedList = [...dataNhanLuc.batchStaffList];
      updatedList[editingIndexTren] = newItem;
      setDataNhanLuc({...dataNhanLuc, batchStaffList: updatedList});
      setEditingIndexTren(null);
    } else {
      setDataNhanLuc({
        ...dataNhanLuc,
        batchStaffList: [newItem, ...dataNhanLuc.batchStaffList]
      });
    }

    setSelectedTiepNhanHoTro(null);
    setSelectedCanBoHoTro(null);
  };

  // Hàm xóa - xóa từ batchStaffList
  const handleDelete = (index: number, staffType: string) => {
    // Lọc ra danh sách theo type
    const itemsOfType = dataNhanLuc.batchStaffList.filter((item: any) => item?.levelType === staffType);
    const itemToDelete = itemsOfType[index];

    // Xóa item khỏi batchStaffList
    const updatedList = dataNhanLuc.batchStaffList.filter((item: any) => item !== itemToDelete);
    setDataNhanLuc({...dataNhanLuc, batchStaffList: updatedList});
    toast.success('Xóa thành công');
  };

  // Hàm lọc dữ liệu theo type để hiển thị trong bảng
  const getDataByType = (staffType: string) => {
    return dataNhanLuc.batchStaffList.filter((item: any) => item?.levelType === staffType);
  };

  useEffect(() => {
    getOptions();
  }, []);

  useEffect(() => {
    setDataNhanLuc({batchStaffList: [...(initialValues?.staffList ?? [])]});
  }, [initialValues?.staffList]);

  useEffect(() => {
    updateForm();
  }, []);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({...generateInitValues(data), ...initialValues});
  };

  const createColumnsForTable = (staffType: string) => [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleDelete(index, staffType)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{cursor: 'pointer'}}
                title="Xóa"
              ></i>
            </div>
        },
      ] : []),
    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "position",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.position || row.item?.position || '',
    },
    {
      name: "Đơn vị",
      field: "unitName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.unitName || row.item?.unitName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "quantityOfficer",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.quantityOfficer || row.item?.quantityOfficer || '',
    },
  ];

  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{[type.formThongTinChung]: initialValues}}
        validationSchema={generateValidationSchema(listJsonGenerate, type.formThongTinChung)}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Biên bản buổi hỗ trợ`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <GenerateFormComponent
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    modelID={type.formThongTinChung}
                  />
                  <h4 className="text-title fw-bold fs-5 spaces mb-5 mt-5">
                    Đối tượng tiếp nhận hỗ trợ kĩ thuật chuyên môn
                  </h4>
                  {!isView && (
                    <Row>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired className="min-w-100px" label="Nhân sự"/>
                          </div>
                        </div>
                      </Col>
                      <Col lg={10} className="spaces">
                        <AutocompleteObjectV2
                          options={thanhVien}
                          value={selectedTiepNhanHoTro}
                          isSearchDefauilt={true}
                          name="WmsCode"
                          onChange={(options: any) => setSelectedTiepNhanHoTro(options)}
                          className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                          isClearable={true}
                          placeholder="Chọn nhân sự..."
                        />
                      </Col>
                      <Col lg={1}>
                        <div className="d-flex mt-8 spaces align-items-center">
                          <Button
                            className="btn-fill spaces min-w-90px btn btn-primary"
                            onClick={() => handleAddOrUpdate(selectedTiepNhanHoTro, STAFF_TYPES.RECIPIENT)}
                            type="button"
                          >
                            <i className="bi bi-plus-lg text-pri fs-3"></i>
                            {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <TableNhanLuc
                    columns={createColumnsForTable(STAFF_TYPES.RECIPIENT)}
                    isView={isView}
                    dsItems={getDataByType(STAFF_TYPES.RECIPIENT)}
                  />

                  <h4 className="text-title fw-bold fs-5 spaces mb-5">
                    Cán bộ hỗ trợ kĩ thuật chuyên môn
                  </h4>
                  {!isView && (
                    <Row>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired className="min-w-100px" label="Nhân sự"/>
                          </div>
                        </div>
                      </Col>
                      <Col lg={10} className="spaces">
                        <AutocompleteObjectV2
                          options={thanhVien}
                          value={selectedCanBoHoTro}
                          isSearchDefauilt={true}
                          name="WmsCode"
                          onChange={(options: any) => setSelectedCanBoHoTro(options)}
                          className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                          isClearable={true}
                          placeholder="Chọn nhân sự..."
                        />
                      </Col>
                      <Col lg={1}>
                        <div className="d-flex mt-8 spaces align-items-center">
                          <Button
                            className="btn-fill spaces min-w-90px btn btn-primary"
                            onClick={() => handleAddOrUpdate(selectedCanBoHoTro, STAFF_TYPES.SUPPORT_STAFF)}
                            type="button"
                          >
                            <i className="bi bi-plus-lg text-pri fs-3"></i>
                            {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <TableNhanLuc
                    columns={createColumnsForTable(STAFF_TYPES.SUPPORT_STAFF)}
                    isView={isView}
                    dsItems={getDataByType(STAFF_TYPES.SUPPORT_STAFF)}
                  />
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {/*{(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (*/}
                {/*  <WfButton*/}
                {/*    additionalFunc={(data: any) => {*/}
                {/*      setDetailPhieuKeHoach({*/}
                {/*        ...detailPhieuKeHoach,*/}
                {/*        status: data?.currCode,*/}
                {/*        statusCode: data?.currCode,*/}
                {/*        statusId: data?.currId,*/}
                {/*      })*/}
                {/*    }}*/}
                {/*    tracker={type.trackerCode}*/}
                {/*    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}*/}
                {/*  />*/}
                {/*)}*/}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
              </div>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogBienBanHoTro;